import { apiGet, apiPatch, apiPost } from './client';

export type SettingDto = {
  key: string;
  name: string;
  description: string;
  category: string;
  default: unknown;
  value: unknown;
  /** True when the platform has stored an override; false means we're on the code default. */
  isOverridden: boolean;
  updatedBy: string | null;
  updatedAt: string | null;
};

export const settingsApi = {
  list: () => apiGet<{ rows: SettingDto[] }>('/api/settings'),
  set: (key: string, value: unknown) =>
    apiPatch<{ ok: true; key: string; value: unknown; updatedBy: string; updatedAt: string }>(
      `/api/settings/${encodeURIComponent(key)}`,
      { value },
    ),
  reset: (key: string) =>
    apiPost<{ ok: true; key: string; value: unknown }>(
      `/api/settings/${encodeURIComponent(key)}/reset`,
    ),
};
